import { Fragment } from 'react';

import { FormattedMessage } from 'react-intl';
import * as PropTypes from 'prop-types';

import { PageWrapper } from 'modules/layout';

import Form from '../../containers/UpdateNewsForm';

const NewsPage = ({ id, delayed }) => (
    <PageWrapper
        header={
            <Fragment>
                <FormattedMessage id="news.update.title" />
            </Fragment>
        }
    >
        <Form id={id} delayed={delayed} />
    </PageWrapper>
);

NewsPage.propTypes = {
    id: PropTypes.string.isRequired,
    delayed: PropTypes.bool,
};

NewsPage.defaultProps = {
    delayed: false,
};

export default NewsPage;
